/**
 * Wholesale Bundle Builder — Glow Superfoods theme integration
 * Single custom element (bundle-builder); one instance per section via data-section-id.
 */
if (!customElements.get('bundle-builder')) {
  customElements.define(
    'bundle-builder',
    class BundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this._bbInitTimer) return;
        this._bbInitTimer = setTimeout(() => this._init(), 0);
      }

      disconnectedCallback() {
        if (this._bbInitTimer) {
          clearTimeout(this._bbInitTimer);
          this._bbInitTimer = null;
        }
        if (this._docClickHandler) {
          document.removeEventListener('click', this._docClickHandler);
          this._docClickHandler = null;
        }
        this._bbReady = false;
      }

      _init() {
        const SID = this.dataset.sectionId;
        if (!SID || this._bbReady) return;
        this._bbReady = true;

        const MIN_TOTAL = parseInt(this.dataset.minTotal || '35000', 10);
        const DISC_PCT = parseInt(this.dataset.discountPct || '0', 10);
        const LIMIT = parseInt(this.dataset.limit || '12', 10);
        const root = this;

        const bundle = {};
        let currentCollection = this.dataset.defaultCollection || '';
        let isLoading = false;
        let hasMore = this.dataset.hasMore === 'true';

        const grid = bbId('bb-grid-' + SID);
        const itemsCont = bbId('bb-items-' + SID);
        const emptyState = bbId('bb-sidebar-empty-' + SID);
        const totalsEl = bbId('bb-totals-' + SID);
        const subtotalEl = bbId('bb-subtotal-' + SID);
        const discountEl = bbId('bb-discount-' + SID);
        const totalEl = bbId('bb-total-' + SID);
        const checkoutBtn = bbId('bb-checkout-' + SID);
        const chkLabel = bbId('bb-checkout-label-' + SID);
        const progFill = bbId('bb-progress-fill-' + SID);
        const progBar = bbId('bb-progress-' + SID);
        const progCount = bbId('bb-progress-count-' + SID);
        const progPct = bbId('bb-progress-pct-' + SID);
        const moqLabel = bbId('bb-moq-label-' + SID);
        const statusCount = bbId('bb-status-count-' + SID);
        const statusBadge = bbQ('.bb-status-badge', root);
        const prodLabel = bbId('bb-prod-label-' + SID);
        const loadMoreBtn = bbId('bb-load-more-' + SID);
        const loadSpinner = bbId('bb-load-spinner-' + SID);
        const hintEl = bbId('bb-grid-hint-' + SID);

        if (!grid || !itemsCont) {
          console.warn('[Bundle Builder] Could not initialize section', SID);
          return;
        }

       const updateBundle = () => {
  let totalQty = 0;
  let totalPrice = 0;
  Object.keys(bundle).forEach((k) => {
    const i = bundle[k];
    totalQty += i.qty;
    totalPrice += i.qty * i.price;
  });

  if (statusCount) statusCount.textContent = bbFmt(totalPrice);
  const met = totalPrice >= MIN_TOTAL;
  if (statusBadge) statusBadge.classList[met ? 'add' : 'remove']('bb-status-badge--met');

  const pct = Math.min(100, MIN_TOTAL > 0 ? (totalPrice / MIN_TOTAL) * 100 : 0);
  if (progFill) {
    progFill.style.width = pct + '%';
    progFill.classList[met ? 'add' : 'remove']('bb-sidebar__progress-fill--done');
  }
  if (progBar) progBar.setAttribute('aria-valuenow', totalPrice);
  if (progCount) progCount.textContent = bbFmt(totalPrice) + ' / ' + bbFmt(MIN_TOTAL);
  if (progPct) progPct.textContent = Math.round(pct) + '%';

  const rem = Math.max(0, MIN_TOTAL - totalPrice);
  if (moqLabel) {
    moqLabel.innerHTML = met
      ? '<strong>Bundle ready!</strong>'
      : 'Add <strong>' + bbFmt(rem) + '</strong> more to unlock checkout';
  }

  const disc = Math.round(totalPrice * DISC_PCT / 100);
  const grand = totalPrice - disc;
  if (subtotalEl) subtotalEl.textContent = bbFmt(totalPrice);
  if (discountEl) discountEl.textContent = '-' + bbFmt(disc);
  if (totalEl) totalEl.textContent = bbFmt(grand);
  if (totalsEl) totalsEl.hidden = totalQty === 0;
  if (emptyState) emptyState.style.display = totalQty > 0 ? 'none' : '';

  if (checkoutBtn) {
    checkoutBtn.disabled = !met;
    checkoutBtn.setAttribute('aria-disabled', String(!met));
  }
  if (chkLabel) {
    chkLabel.textContent = met
      ? 'Checkout — ' + bbFmt(grand)
      : bbFmt(rem) + ' more needed to checkout';
  }

  renderSidebarItems();
};

        const renderSidebarItems = () => {
          bbQA('.bb-bundle-item', itemsCont).forEach((el) => el.remove());
          Object.keys(bundle).forEach((key) => {
            const item = bundle[key];
            if (!item || item.qty <= 0) {
              delete bundle[key];
              return;
            }
            const row = document.createElement('div');
            row.className = 'bb-bundle-item';
            row.dataset.key = key;
            row.innerHTML =
              '<div class="bb-bundle-item__info">' +
              '<span class="bb-bundle-item__name">' +
              bbEsc(item.title) +
              '</span>' +
              '<span class="bb-bundle-item__meta">' +
              (item.variantLabel ? bbEsc(item.variantLabel) + ' · ' : '') +
              bbFmt(item.price) +
              '</span>' +
              '</div>' +
              '<span class="bb-bundle-item__qty">×' +
              item.qty +
              '</span>' +
              '<button type="button" class="bb-bundle-item__remove" aria-label="Remove ' +
              bbEsc(item.title) +
              '" data-bb-key="' +
              bbEsc(key) +
              '" data-bb-product-id="' +
              bbEsc(item.productId) +
              '">×</button>';
            if (item.image) {
              row.insertBefore(bbImg('bb-bundle-item__img', item.image, item.title, 42, 42), row.firstChild);
            } else {
              const placeholder = document.createElement('div');
              placeholder.className = 'bb-bundle-item__img';
              placeholder.style.background = '#f0efec';
              row.insertBefore(placeholder, row.firstChild);
            }
            itemsCont.insertBefore(row, emptyState);
          });
        };

        itemsCont.addEventListener('click', (e) => {
          const btn = e.target.closest('.bb-bundle-item__remove');
          if (!btn) return;
          const key = btn.dataset.bbKey;
          const productId = btn.dataset.bbProductId;
          if (!key) return;
          delete bundle[key];
          btn.closest('.bb-bundle-item')?.remove();
          if (productId) {
            const card = bbQ('[data-product-id="' + productId + '"]', grid);
            if (card) resetCard(card);
          }
          updateBundle();
        });

        const resetCard = (card) => {
          const btn = bbQ('.bb-btn--add', card);
          const qtyIn = bbQ('.bb-qty-input', card);
          if (!btn) return;
          btn.dataset.state = 'idle';
          const t = btn.querySelector('.bb-btn__text');
          if (t) t.textContent = 'Add to Cart';
          if (qtyIn) qtyIn.value = 1;
          card.classList.remove('bb-card--in-bundle');
        };

        const getChosenOptions = (card) => {
          const chosen = {};
          const order = [];
          bbQA('.bb-variant-group', card).forEach((grp) => {
            const select = bbQ('.bb-select', grp);
            if (select && select.dataset.option) {
              chosen[select.dataset.option] = select.value;
              order.push(select.dataset.option);
              return;
            }
            const active = bbQ('.bb-swatch--active', grp);
            if (active && active.dataset.option) {
              chosen[active.dataset.option] = active.dataset.value;
              order.push(active.dataset.option);
            }
          });
          return { chosen, order };
        };

        const getVariant = (card) => {
          const raw = card.dataset.variants;
          if (!raw) return null;
          const variants = bbJSON(raw);
          if (!variants || !variants.length) return null;

          const { chosen, order } = getChosenOptions(card);
          if (!order.length) return variants[0];

          const matched = variants.find((v) =>
            order.every((name, i) => {
              const val = chosen[name];
              const vOpt = v['option' + (i + 1)];
              return vOpt === val;
            })
          );
          return matched || variants[0];
        };

        const applyVariantToCard = (card, variant) => {
          if (!variant) return;
          const btn = bbQ('.bb-btn--add', card);
          const priceEl = bbQ('.bb-card__price', card);
          const priceRow = bbQ('.bb-card__price-row', card);
          let compareEl = bbQ('.bb-card__price-compare', card);

          const cents = bbPriceToCents(variant.price);
          const compareCents = variant.compare_at_price ? bbPriceToCents(variant.compare_at_price) : 0;

          if (priceEl) {
            priceEl.textContent = bbFmt(cents);
            priceEl.classList.add('bb-card__price--pulse');
            window.setTimeout(() => priceEl.classList.remove('bb-card__price--pulse'), 350);
          }

          if (compareCents > cents && priceRow) {
            if (!compareEl) {
              compareEl = document.createElement('span');
              compareEl.className = 'bb-card__price-compare';
              priceRow.appendChild(compareEl);
            }
            compareEl.textContent = bbFmt(compareCents);
            compareEl.hidden = false;
          } else if (compareEl) {
            compareEl.remove();
          }

          if (btn) {
            btn.dataset.variantId = String(variant.id);
            btn.dataset.productPriceRaw = String(cents);
            btn.dataset.productPrice = bbFmt(cents);
            const available = variant.available !== false;
            btn.disabled = !available;
            if (available) {
              btn.removeAttribute('disabled');
            } else {
              btn.setAttribute('disabled', '');
            }
            const txt = btn.querySelector('.bb-btn__text');
            if (txt && btn.dataset.state !== 'added') {
              txt.textContent = available ? 'Add to Cart' : 'Unavailable';
            }
          }
        };

        const syncBundleOnVariantChange = (card, oldVariantId, variant) => {
          const productId = card.dataset.productId;
          if (!productId || !variant) return;

          const newVariantId = String(variant.id);
          if (!oldVariantId || oldVariantId === newVariantId) return;

          const oldKey = productId + '-' + oldVariantId;
          const newKey = productId + '-' + newVariantId;

          if (!bundle[oldKey]) return;

          const item = bundle[oldKey];
          delete bundle[oldKey];

          const price = bbPriceToCents(variant.price);
          const variantLabel =
            variant.title && variant.title !== 'Default Title' ? variant.title : '';

          if (bundle[newKey]) {
            bundle[newKey].qty += item.qty;
            bundle[newKey].price = price;
            bundle[newKey].variantLabel = variantLabel;
          } else {
            bundle[newKey] = {
              productId: productId,
              variantId: newVariantId,
              title: item.title,
              image: item.image,
              price: price,
              qty: item.qty,
              variantLabel: variantLabel,
            };
          }

          card.classList.add('bb-card--in-bundle');
          updateBundle();
        };

        const onCardVariantChange = (card) => {
          const btn = bbQ('.bb-btn--add', card);
          const oldVariantId = btn ? btn.dataset.variantId : null;
          const variant = getVariant(card);
          if (!variant) return;
          applyVariantToCard(card, variant);
          syncBundleOnVariantChange(card, oldVariantId, variant);
        };

        const bindCard = (card) => {
          if (card.dataset.bbBound === '1') return;
          card.dataset.bbBound = '1';

          const btn = bbQ('.bb-btn--add', card);
          const qtyIn = bbQ('.bb-qty-input', card);
          const minus = bbQ('.bb-qty-btn--minus', card);
          const plus = bbQ('.bb-qty-btn--plus', card);
          if (!btn) return;

          if (minus) {
            minus.addEventListener('click', (e) => {
              e.preventDefault();
              const v = parseInt(qtyIn?.value || '1', 10) || 1;
              if (v > 1 && qtyIn) qtyIn.value = v - 1;
            });
          }
          if (plus) {
            plus.addEventListener('click', (e) => {
              e.preventDefault();
              const v = parseInt(qtyIn?.value || '1', 10) || 1;
              if (v < 99 && qtyIn) qtyIn.value = v + 1;
            });
          }

          btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (btn.disabled) return;

            const qty = parseInt(qtyIn?.value || '1', 10) || 1;
            const variant = getVariant(card);
            const variantId =
              variant && variant.id ? String(variant.id) : btn.dataset.variantId || null;

            if (!variantId) {
              console.warn('[Bundle Builder] No variant for product', btn.dataset.productId);
              return;
            }

            const key = btn.dataset.productId + '-' + variantId;
            const priceRaw =
              variant && variant.price != null
                ? bbPriceToCents(variant.price)
                : parseInt(btn.dataset.productPriceRaw || '0', 10);

            if (bundle[key]) {
              bundle[key].qty += qty;
            } else {
              bundle[key] = {
                productId: btn.dataset.productId,
                variantId: variantId,
                title: btn.dataset.productTitle || '',
                image: btn.dataset.productImage || '',
                price: priceRaw,
                qty: qty,
                variantLabel:
                  variant && variant.title && variant.title !== 'Default Title' ? variant.title : '',
              };
            }

            btn.dataset.state = 'added';
            const txt = btn.querySelector('.bb-btn__text');
            if (txt) txt.textContent = 'Added';
            card.classList.add('bb-card--in-bundle');

            setTimeout(() => {
              btn.dataset.state = 'idle';
              if (txt) txt.textContent = 'Add to Cart';
            }, 1800);

            updateBundle();
          });

          bbQA('.bb-variant-group', card).forEach((grp) => {
            bbQA('.bb-swatch', grp).forEach((sw) => {
              sw.addEventListener('click', (e) => {
                e.preventDefault();
                bbQA('.bb-swatch--active', grp).forEach((a) => a.classList.remove('bb-swatch--active'));
                sw.classList.add('bb-swatch--active');
                onCardVariantChange(card);
              });
            });
            const select = bbQ('.bb-select', grp);
            if (select) {
              select.addEventListener('change', () => onCardVariantChange(card));
            }
          });

          const initialVariant = getVariant(card);
          if (initialVariant) applyVariantToCard(card, initialVariant);
        };

        const injectCard = (p) => {
          if (bbQ('[data-product-id="' + p.id + '"]', grid)) return;

          let varHtml = '';
          const opts = p.options || [];
          const hasOpts = opts.length > 0 && !(opts.length === 1 && opts[0].name === 'Title');
          if (hasOpts) {
            varHtml = '<div class="bb-card__variants">';
            opts.forEach((opt) => {
              const isColor = opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour';
              varHtml +=
                '<div class="bb-variant-group"><label class="bb-variant-group__label">' +
                bbEsc(opt.name) +
                '</label><div class="bb-variant-group__options">';
              if (isColor) {
                (opt.values || []).forEach((v, i) => {
                  varHtml +=
                    '<button type="button" class="bb-swatch' +
                    (i === 0 ? ' bb-swatch--active' : '') +
                    '" data-option="' +
                    bbEsc(opt.name) +
                    '" data-value="' +
                    bbEsc(v) +
                    '" title="' +
                    bbEsc(v) +
                    '" style="--swatch-color:' +
                    String(v).toLowerCase().replace(/\s+/g, '') +
                    ';"><span class="bb-swatch__inner"></span></button>';
                });
              } else {
                varHtml +=
                  '<select class="bb-select" data-option="' +
                  bbEsc(opt.name) +
                  '" aria-label="' +
                  bbEsc(opt.name) +
                  '">';
                (opt.values || []).forEach((v) => {
                  varHtml += '<option value="' + bbEsc(v) + '">' + bbEsc(v) + '</option>';
                });
                varHtml += '</select>';
              }
              varHtml += '</div></div>';
            });
            varHtml += '</div>';
          }

          const imgSrc = p.image || '';
          const firstVar = (p.variants && p.variants[0]) || {};
          const variantId = p.variantId || firstVar.id || '';

          const card = document.createElement('div');
          card.className = 'bb-card';
          card.dataset.productId = String(p.id);
          card.dataset.productHandle = p.handle || '';
          if (p.variants && p.variants.length) card.dataset.variants = JSON.stringify(p.variants);

          card.innerHTML =
            '<div class="bb-card__img-wrap">' +
            (imgSrc
              ? '<span class="bb-card__img-slot"></span>'
              : '<div class="bb-card__img-placeholder"></div>') +
            '</div>' +
            '<div class="bb-card__body">' +
            '<p class="bb-card__vendor">' +
            bbEsc(p.vendor || '') +
            '</p>' +
            '<h3 class="bb-card__title">' +
            bbEsc(p.title) +
            '</h3>' +
            '<div class="bb-card__price-row"><span class="bb-card__price">' +
            bbEsc(p.price || '') +
            '</span></div>' +
            varHtml +
            '<div class="bb-card__cta">' +
            '<div class="bb-qty-controls">' +
            '<button type="button" class="bb-qty-btn bb-qty-btn--minus" aria-label="Decrease">-</button>' +
            '<input class="bb-qty-input" type="number" min="1" max="99" value="1" aria-label="Quantity">' +
            '<button type="button" class="bb-qty-btn bb-qty-btn--plus" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="bb-btn bb-btn--add" data-state="idle"' +
            ' data-product-id="' +
            bbEsc(p.id) +
            '"' +
            ' data-variant-id="' +
            bbEsc(variantId) +
            '"' +
            ' data-product-title="' +
            bbEsc(p.title) +
            '"' +
            ' data-product-image="' +
            bbEsc(imgSrc) +
            '"' +
            ' data-product-price="' +
            bbEsc(p.price || '') +
            '"' +
            ' data-product-price-raw="' +
            (p.priceRaw || 0) +
            '">' +
            '<span class="bb-btn__text">Add to Cart</span>' +
            '<svg class="bb-btn__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 4h2l2.5 8h7l2-6H7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="16" r="1" fill="currentColor"/><circle cx="14" cy="16" r="1" fill="currentColor"/></svg>' +
            '</button>' +
            '</div>' +
            '</div>';

          if (imgSrc) {
            const imgSlot = bbQ('.bb-card__img-slot', card);
            if (imgSlot?.parentNode) {
              imgSlot.parentNode.replaceChild(bbImg('bb-card__img', imgSrc, p.title, 400, 400), imgSlot);
            }
          }

          grid.appendChild(card);
          bindCard(card);

          card.style.opacity = '0';
          card.style.transform = 'translateY(10px)';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              card.style.transition = 'opacity .28s ease, transform .28s ease';
              card.style.opacity = '1';
              card.style.transform = 'translateY(0)';
            });
          });
        };

        const loadCollection = (handle, page, replace) => {
          if (isLoading) return;
          isLoading = true;

          if (replace) {
            grid.innerHTML =
              '<div class="bb-grid-message">Loading…</div>';
            if (loadMoreBtn) loadMoreBtn.hidden = true;
          }
          if (loadMoreBtn) loadMoreBtn.hidden = true;
          if (loadSpinner) loadSpinner.hidden = false;

          const url = handle
            ? '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + LIMIT + '&page=' + page
            : '/products.json?limit=' + LIMIT + '&page=' + page;

          window
            .fetch(url, { credentials: 'same-origin' })
            .then((r) => {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.json();
            })
            .then((data) => {
              const products = data.products || [];
              if (replace) grid.innerHTML = '';

              if (!products.length && replace) {
                grid.innerHTML =
                  '<div class="bb-grid-message">No products found in this collection.</div>';
                hasMore = false;
              } else {
                products.forEach((p) => {
                  const fv = (p.variants && p.variants[0]) || {};
                  const priceRaw = bbPriceToCents(fv.price || 0);
                  injectCard({
                    id: p.id,
                    handle: p.handle,
                    title: p.title,
                    image: p.images && p.images[0] ? p.images[0].src : '',
                    price: bbFmt(priceRaw),
                    priceRaw: priceRaw,
                    vendor: p.vendor,
                    variantId: fv.id || '',
                    variants: p.variants || [],
                    options: bbNormalizeProductOptions(p),
                  });
                });
                hasMore = products.length === LIMIT;
              }

              if (loadMoreBtn) {
                loadMoreBtn.hidden = !hasMore;
                loadMoreBtn.dataset.page = String(page + 1);
                loadMoreBtn.dataset.collection = handle || '';
              }
              if (loadSpinner) loadSpinner.hidden = true;

              if (hintEl && handle) {
                const activeTab = bbQ('.bb-tab--active', root);
                const title = activeTab ? activeTab.dataset.collectionTitle || handle : handle;
                hintEl.innerHTML = 'Showing products from <strong>' + bbEsc(title) + '</strong>';
              }
            })
            .catch((err) => {
              console.error('[Bundle Builder] loadCollection:', err);
              if (replace) {
                grid.innerHTML =
                  '<div class="bb-grid-message bb-grid-message--error">Could not load products. Please try again.</div>';
              }
              if (loadMoreBtn) loadMoreBtn.hidden = false;
              if (loadSpinner) loadSpinner.hidden = true;
            })
            .finally(() => {
              isLoading = false;
            });
        };

        if (loadMoreBtn) {
          loadMoreBtn.addEventListener('click', () => {
            const page = parseInt(loadMoreBtn.dataset.page || '2', 10);
            const handle = loadMoreBtn.dataset.collection || '';
            loadCollection(handle, page, false);
          });
        }

        bbQA('.bb-tab', root).forEach((tab) => {
          tab.addEventListener('click', (e) => {
            e.preventDefault();
            bbQA('.bb-tab', root).forEach((t) => {
              t.classList.remove('bb-tab--active');
              t.setAttribute('aria-selected', 'false');
            });
            tab.classList.add('bb-tab--active');
            tab.setAttribute('aria-selected', 'true');

            const handle = tab.dataset.collectionHandle;
            const title = tab.dataset.collectionTitle || handle;
            currentCollection = handle;
            if (hintEl) hintEl.innerHTML = 'Showing products from <strong>' + bbEsc(title) + '</strong>';
            loadCollection(handle, 1, true);
            closeAll();
          });
        });

        const closeAll = () => {
          bbQA('.bb-pill__trigger[aria-expanded="true"]', root).forEach((t) => {
            t.setAttribute('aria-expanded', 'false');
          });
          bbQA('.bb-pill__dropdown', root).forEach((d) => {
            d.hidden = true;
          });
        };

        this._docClickHandler = (e) => {
          const path = e.composedPath ? e.composedPath() : [];
          if (!path.includes(root)) closeAll();
        };
        document.addEventListener('click', this._docClickHandler);

        const prodTrigger = bbQ('[data-pill="product"]', root);
        const prodDropdown = bbId('bb-prod-dropdown-' + SID);

        if (prodTrigger && prodDropdown) {
          prodTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const open = prodTrigger.getAttribute('aria-expanded') === 'true';
            closeAll();
            if (!open) {
              prodTrigger.setAttribute('aria-expanded', 'true');
              prodDropdown.hidden = false;
              const s = prodDropdown.querySelector('.bb-pill__search');
              if (s) setTimeout(() => s.focus(), 50);
            }
          });
          prodDropdown.addEventListener('click', (e) => e.stopPropagation());
        }

        bbQA('.bb-pill__option--product', root).forEach((opt) => {
          opt.addEventListener('click', () => {
            const sel = opt.getAttribute('aria-selected') === 'true';
            opt.setAttribute('aria-selected', sel ? 'false' : 'true');
            opt.classList[sel ? 'remove' : 'add']('bb-pill__option--active');

            if (!sel) {
              injectCard({
                id: opt.dataset.productId,
                handle: opt.dataset.productHandle,
                title: opt.dataset.productTitle,
                image: opt.dataset.productImage,
                price: opt.dataset.productPrice,
                priceRaw: parseInt(opt.dataset.productPriceRaw || '0', 10),
                vendor: opt.dataset.productVendor,
                variantId: opt.dataset.productVariantId || '',
                variants: opt.dataset.productVariants ? bbJSON(opt.dataset.productVariants) : [],
              });
            } else {
              const card = bbQ('[data-product-id="' + opt.dataset.productId + '"]', grid);
              if (card) {
                resetCard(card);
                card.remove();
              }
            }

            const n = bbQA('.bb-pill__option--product[aria-selected="true"]', root).length;
            if (prodLabel) {
              prodLabel.textContent = n > 0 ? n + ' product' + (n > 1 ? 's' : '') + ' added' : 'Add Products';
            }
          });
        });

        const prodSearch = bbQ('[data-target="product-search"]', root);
        if (prodSearch) {
          prodSearch.addEventListener('input', function () {
            const q = this.value.trim().toLowerCase();
            let any = false;
            bbQA('.bb-pill__option--product', root).forEach((o) => {
              const title = (o.dataset.productTitle || '').toLowerCase();
              const visible = !q || title.indexOf(q) !== -1;
              o.style.display = visible ? '' : 'none';
              if (visible) any = true;
            });
            const emptyMsg = bbId('bb-prod-empty-' + SID);
            if (emptyMsg) emptyMsg.hidden = !(q && !any);
          });
        }

        if (checkoutBtn) {
          checkoutBtn.addEventListener('click', () => {
            if (checkoutBtn.disabled) return;

            const items = [];
            let invalid = false;
            Object.keys(bundle).forEach((k) => {
              const item = bundle[k];
              if (!item.variantId) {
                invalid = true;
                return;
              }
              items.push({ id: parseInt(item.variantId, 10), quantity: item.qty });
            });

            if (invalid || !items.length) {
              alert('Some products are missing variant information. Please re-select them.');
              return;
            }

            checkoutBtn.disabled = true;
            checkoutBtn.setAttribute('aria-disabled', 'true');
            if (chkLabel) chkLabel.textContent = 'Adding to cart…';

            const cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

            window
              .fetch(cartUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: items }),
              })
              .then((r) => {
                if (!r.ok) return r.json().then((e) => Promise.reject(new Error(e.description || 'Cart error')));
                return r.json();
              })
              .then(() => {
                window.location.href = '/checkout';
              })
              .catch((err) => {
                console.error('[Bundle Builder] checkout:', err);
                checkoutBtn.disabled = false;
                checkoutBtn.setAttribute('aria-disabled', 'false');
                if (chkLabel) chkLabel.textContent = 'Retry checkout';
                alert('Could not add to cart: ' + (err.message || 'Please try again.'));
              });
          });
        }

        bbQA('.bb-card', root).forEach(bindCard);
        updateBundle();
      }
    }
  );
}

function bbQ(sel, ctx) {
  return (ctx || document).querySelector(sel);
}
function bbQA(sel, ctx) {
  return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
}
function bbId(id) {
  return document.getElementById(id);
}
function bbEsc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
function bbFmt(cents) {
  const currency =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.activeCurrency) ||
    'USD';
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
    }).format(cents / 100);
  } catch (e) {
    return '$' + (cents / 100).toFixed(2);
  }
}
/** Shopify Liquid variant prices are cents (int); Products JSON API uses dollar strings. */
function bbPriceToCents(val) {
  if (val == null || val === '') return 0;
  if (typeof val === 'string' && val.indexOf('.') !== -1) {
    return Math.round(parseFloat(val) * 100);
  }
  const n = parseInt(val, 10);
  return isNaN(n) ? 0 : n;
}
function bbJSON(s) {
  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
}
function bbImg(className, src, alt, width, height) {
  const img = document.createElement('img');
  img.className = className;
  img.src = src;
  img.alt = alt || '';
  img.loading = 'lazy';
  img.width = width;
  img.height = height;
  return img;
}

/** Products JSON API returns option names as strings; Liquid uses {name, values} objects. */
function bbNormalizeProductOptions(product) {
  const options = product.options || [];
  if (!options.length) return [];
  if (typeof options[0] === 'object' && options[0].name) return options;

  return options.map((name, index) => {
    const key = 'option' + (index + 1);
    const values = [];
    (product.variants || []).forEach((variant) => {
      const val = variant[key];
      if (val && values.indexOf(val) === -1) values.push(val);
    });
    return { name: name, values: values };
  });
}
